export class ClienteFilial {
    cd_filial: number;
    nm_filial: string;
    nmFantasia: string;
    imgStr: string;
}



